export interface ImageInfo {
  src: string;
  alt: string;
}

export interface PartnerInfo extends ImageInfo {
  name: string;
}

const siteImages = {
  logo: {
    src: "/assets/images/brand/logo.png",
    alt: "Ecocerram logo"
  },
  imageError: {
    en: {
      src: "/assets/images/errors/error-en.png",
      alt: "Image error EN"
    },
    sk: {
      src: "/assets/images/errors/error-sk.png",
      alt: "Image error SK"
    },
    de: {
      src: "/assets/images/errors/error-de.png",
      alt: "Image error DE"
    },
    pl: {
      src: "/assets/images/errors/error-pl.png",
      alt: "Image error PL"
    },
    hu: {
      src: "/assets/images/errors/error-hu.png",
      alt: "Image error HU"
    }
  },
  bannerDesktop: null as ImageInfo | null,
  bannerMobile: null as ImageInfo | null,
  bannerCta: {
    sk: "Zobraziť produkty"
  },
  bannerDate: {
    sk: "2025-08-11"
  },
  facebook: {
    src: "/assets/images/brand/facebook.png",
    alt: "Facebook logo"
  },
  instagram: {
    src: "/assets/images/brand/instagram.png",
    alt: "Instagram logo"
  },
  introImages: [
    {
      src: "/assets/images/intro/alabaster-sky.png",
      alt: "Alabaster Sky"
    },
    {
      src: "/assets/images/intro/arkesia-rust.png",
      alt: "Arkesia Rust"
    },
    {
      src: "/assets/images/intro/statuario-nero.png",
      alt: "Statuario Nero"
    }
  ],
  aboutCategoryImages: [
    {
      src: "/assets/images/brand/category-storage.jpg",
      alt: "Category storage"
    },
    {
      src: "/assets/images/brand/category-partners.jpg",
      alt: "Category partners"
    },
    {
      src: "/assets/images/brand/category-time.jpg",
      alt: "Category time"
    }
  ],
  aboutLogos: [
    {
      src: "/assets/images/partners/hornbach.png",
      alt: "Hornbach logo"
    },
    {
      src: "/assets/images/partners/obi.png",
      alt: "Obi logo"
    },
    {
      src: "/assets/images/partners/bauhaus.png",
      alt: "Bauhaus logo"
    },
    {
      src: "/assets/images/partners/uni_hobby.png",
      alt: "Uni Hobby logo"
    }
  ],
  partners: [
    {
      name: "Obi",
      src: "/assets/images/partners/obi.png",
      alt: "Obi"
    },
    {
      name: "Hornbach",
      src: "/assets/images/partners/hornbach.png",
      alt: "Hornbach"
    },
    {
      name: "Bauhaus",
      src: "/assets/images/partners/bauhaus.png",
      alt: "Bauhaus"
    }
  ],
  showroomPhotos: [
    { src: "/assets/images/showroom/showroom_1.jpg", alt: "Showroom 1" },
    { src: "/assets/images/showroom/showroom_2.jpg", alt: "Showroom 2" },
    { src: "/assets/images/showroom/showroom_3.jpg", alt: "Showroom 3" },
    { src: "/assets/images/showroom/showroom_4.jpg", alt: "Showroom 4" },
    { src: "/assets/images/showroom/showroom_5.jpg", alt: "Showroom 5" },
    { src: "/assets/images/showroom/showroom_6.jpg", alt: "Showroom 6" },
    { src: "/assets/images/showroom/showroom_7.jpg", alt: "Showroom 7" },
    { src: "/assets/images/showroom/showroom_8.jpg", alt: "Showroom 8" },
    { src: "/assets/images/showroom/showroom_9.jpg", alt: "Showroom 9" },
    { src: "/assets/images/showroom/showroom_10.jpg", alt: "Showroom 10" },
    { src: "/assets/images/showroom/showroom_11.jpg", alt: "Showroom 11" },
    { src: "/assets/images/showroom/showroom_12.jpg", alt: "Showroom 12" },
    { src: "/assets/images/showroom/showroom_13.jpg", alt: "Showroom 13" },
    { src: "/assets/images/showroom/showroom_14.jpg", alt: "Showroom 14" },
    { src: "/assets/images/showroom/showroom_15.jpg", alt: "Showroom 15" },
    { src: "/assets/images/showroom/showroom_16.jpg", alt: "Showroom 16" },
    { src: "/assets/images/showroom/showroom_17.jpg", alt: "Showroom 17" },
    { src: "/assets/images/showroom/showroom_18.jpg", alt: "Showroom 18" },
    { src: "/assets/images/showroom/showroom_19.jpg", alt: "Showroom 19" },
    { src: "/assets/images/showroom/showroom_20.jpg", alt: "Showroom 20" },
    { src: "/assets/images/showroom/showroom_21.jpg", alt: "Showroom 21" },
    { src: "/assets/images/showroom/showroom_22.jpg", alt: "Showroom 22" },
    { src: "/assets/images/showroom/showroom_23.jpg", alt: "Showroom 23" },
    { src: "/assets/images/showroom/showroom_24.jpg", alt: "Showroom 24" },
    { src: "/assets/images/showroom/showroom_25.jpg", alt: "Showroom 25" },
    { src: "/assets/images/showroom/showroom_26.jpg", alt: "Showroom 26" },
    { src: "/assets/images/showroom/showroom_27.jpg", alt: "Showroom 27" }
  ],
  warehousePhotos: [
    { src: "/assets/images/warehouse/warehouse_1.jpg", alt: "Warehouse 1" },
    { src: "/assets/images/warehouse/warehouse_2.jpg", alt: "Warehouse 2" },
    { src: "/assets/images/warehouse/warehouse_3.jpg", alt: "Warehouse 3" },
    { src: "/assets/images/warehouse/warehouse_4.jpg", alt: "Warehouse 4" },
    { src: "/assets/images/warehouse/warehouse_5.jpg", alt: "Warehouse 5" },
    { src: "/assets/images/warehouse/warehouse_6.jpg", alt: "Warehouse 6" },
    { src: "/assets/images/warehouse/warehouse_7.jpg", alt: "Warehouse 7" },
    { src: "/assets/images/warehouse/warehouse_8.jpg", alt: "Warehouse 8" },
    { src: "/assets/images/warehouse/warehouse_9.jpg", alt: "Warehouse 9" },
    { src: "/assets/images/warehouse/warehouse_10.jpg", alt: "Warehouse 10" },
    { src: "/assets/images/warehouse/warehouse_11.jpg", alt: "Warehouse 11" },
    { src: "/assets/images/warehouse/warehouse_12.jpg", alt: "Warehouse 12" },
    { src: "/assets/images/warehouse/warehouse_13.jpg", alt: "Warehouse 13" },
    { src: "/assets/images/warehouse/warehouse_14.jpg", alt: "Warehouse 14" },
    { src: "/assets/images/warehouse/warehouse_15.jpg", alt: "Warehouse 15" },
    { src: "/assets/images/warehouse/warehouse_16.jpg", alt: "Warehouse 16" },
    { src: "/assets/images/warehouse/warehouse_17.jpg", alt: "Warehouse 17" },
    { src: "/assets/images/warehouse/warehouse_18.jpg", alt: "Warehouse 18" },
    { src: "/assets/images/warehouse/warehouse_19.jpg", alt: "Warehouse 19" },
    { src: "/assets/images/warehouse/warehouse_20.jpg", alt: "Warehouse 20" },
    { src: "/assets/images/warehouse/warehouse_21.jpg", alt: "Warehouse 21" },
    { src: "/assets/images/warehouse/warehouse_22.jpg", alt: "Warehouse 22" },
    { src: "/assets/images/warehouse/warehouse_23.jpg", alt: "Warehouse 23" },
    { src: "/assets/images/warehouse/warehouse_24.jpg", alt: "Warehouse 24" },
    { src: "/assets/images/warehouse/warehouse_25.jpg", alt: "Warehouse 25" },
    { src: "/assets/images/warehouse/warehouse_26.jpg", alt: "Warehouse 26" },
    { src: "/assets/images/warehouse/warehouse_27.jpg", alt: "Warehouse 27" }
  ],
  termsPdf: {
    src: "/assets/documents/terms.pdf",
    title: "Terms and conditions"
  }
} as const;

export default siteImages;
